import DataTable from "react-data-table-component";
import { DeleteIcon, ArchiveIcon } from "../../../../assets/icons";
import { getDataTableCustomStyles } from "../../../../helpers/dataTableThemeStyles";
import "./BibliografiaTable.scss";

const customStyles = getDataTableCustomStyles();

const BibliografiaTable = ({
  edit,
  bibliografiaData,
  handleDeleteBibliografia,
  handleBibliografiaView,
}) => {
  const columns = [
    {
      name: "Titolo",
      selector: (row) => row.titolo,
      sortable: true,
    },
    {
      name: "Abbreviazione",
      selector: (row) => row.abbreviazione,
      sortable: true,
    },
    {
      name: "Note",
      selector: (row) => row.note,
      sortable: true,
    },
    {
      name: "",
      selector: (row) => row.id,
      cell: (row) => (
        <div>
          {edit ? (
            <div>
              <button
                className="action-btn"
                onClick={() => handleDeleteBibliografia(row.id)}
              >
                <DeleteIcon />
              </button>
            </div>
          ) : (
            <button
              className="action-btn"
              onClick={() => handleBibliografiaView(row.id)}
            >
              <ArchiveIcon fillColor="var(--archeo-color)" />
            </button>
          )}
        </div>
      ),
    },
  ];

  // console.log("bibliografiaTableData-->>", bibliografiaData);

  return (
    <div>
      <DataTable
        columns={columns}
        data={bibliografiaData}
        customStyles={customStyles}
      />
    </div>
  );
};

export default BibliografiaTable;
